import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import Megatron from '../../../components/megatron/megatron';
import FeatureFeed from '../../../components/feature_feed/feature_feed';
import Ad from '../../../components/ad/ad';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import AllFeed from '../../../components/all_feed/all_feed';
import VideoModule from '../../../components/video_module/video_module';
import Slug from '../../../components/slug/slug';
import FeatureTerm from '../../../components/feature_term/feature_term';
import FranchiseRow from '../../../components/franchise_showcase/franchise_showcase';
import MoreStories from '../../../components/more-stories-component/more-stories-component';
import allFeedISActions from '../../../../redux/actions/homepage/async_is_all_feed_actions';
import { hideRecircAction } from '../../../../redux/actions/async_recirc_feed_actions';

// eslint-disable-next-line react/prefer-stateless-function
class Homepage extends Component {
  render() {
    const page = get(this.props, 'allFeed.page');
    const pageParam = get(this.props, 'match.params.page', false);
    const totalPages = get(this.props, 'allFeed.totalPages');
    const isLastPage = Number(page) >= totalPages;

    const { config, homepageTag, megatronNativeTile } = this.props;
    const tags = get(homepageTag, 'posts[0].tags') || [];

    if (this.props.homepage.error) {
      return (
        <section className="homepage-page">
          <article className="homepage-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.homepage.isLoading) {
      return (
        <section className="homepage-page">
          <article className="homepage-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const adData = get(this.props, 'homepage.ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    const featureFeedCombined = get(this.props, 'featuredFeed.combined', []);
    // TODO: find out from Tom how featured is determined
    const megatronArticles = featureFeedCombined.slice(0, 3);
    const megatronFeatured = featureFeedCombined.slice(3);

    if (!pageParam && get(this.props, 'location.pathname') === '/') {
      return (
        <section className="homepage-page">
          {/* OOP ad here isn't shown on homepage and probably shows up as SIVT ad */}
          {/* <Ad {...combinedAdModel} name="oop" slug={false} oop={true} /> */}
          <div className="homepage-desktop">
            <Megatron
              articles={megatronArticles}
              config={config}
              combinedAdModel={combinedAdModel}
              megatronNativeTile={megatronNativeTile}
              loading="eager"
            />
            <FeatureFeed
              adPostion={2}
              featuredFeed={{ featured: megatronFeatured }}
              promoBanner={this.props.promoBanner}
              scrollingModule={{}}
              combinedAdModel={combinedAdModel}
              page="homepage"
              featuredSponsoredCard={this.props.featuredSponsoredCard}
              config={config}
              shouldRenderDesktop={true}
              loading="lazy"
            />
          </div>
          <div className="homepage-mobile">
            {/*
              <div className="homepage-mobile__featured-covid">
                UPDATES: <a href="/section/coronavirus">COVID-19</a>
              </div>
            */}
            <FeatureFeed
              featuredFeed={this.props.featuredFeed}
              promoBanner={this.props.promoBanner}
              scrollingModule={{}}
              combinedAdModel={combinedAdModel}
              page="homepage"
              featuredSponsoredCard={this.props.featuredSponsoredCard}
              config={config}
              shouldRenderDesktop={false}
              loading="lazy"
            />
            {get(this.props, 'featuredFeed.top.length') >= 2 ? (
              <div className="homepage-page__ff-ad-container">
                <Ad {...combinedAdModel} name="mobilerectangle_1" />
              </div>
            ) : (
              ''
            )}
          </div>

          <FeatureTerm data={this.props.homepageFeatureTerm} config={config} />

          <section className="homepage-tag">
            <MoreStories
              metadata={get(this.props, 'homepageTag.posts')}
              slugData={get(this.props, 'homepageTag.tags[0]')}
              tags={tags}
              config={config}
            />
          </section>

          {get(this.props, 'homepageTag.posts.length') ? (
            <div className="homepage-page__tag-ad-container">
              <Ad {...combinedAdModel} name="flexiblebillboard_3" />
              <Ad {...combinedAdModel} name="mobileparallax_2" />
            </div>
          ) : (
            ''
          )}

          <VideoModule
            config={config}
            data={this.props.homepageVideo}
            playerid="76APbejE"
            stories={this.props.homepageVideo.playlist}
          />

          {get(this.props, 'homepageVideo.playlist.length') ? (
            <div className="homepage-page__video-ad-container">
              <Ad {...combinedAdModel} name="flexiblebillboard_4" />
              <Ad {...combinedAdModel} name="mobilerectangle_2" />
            </div>
          ) : (
            ''
          )}

          <FranchiseRow config={config} />

          {!get(this.props, 'homepageVideo.playlist.length') ? (
            <div className="homepage-page__video-ad-container">
              <Ad {...combinedAdModel} name="flexiblebillboard_3" />
              <Ad {...combinedAdModel} name="mobilerectangle_2" />
            </div>
          ) : (
            <div className="homepage-page__video-ad-container">
              <Ad {...combinedAdModel} name="flexiblebillboard_5" />
              <Ad {...combinedAdModel} name="mobilerectangle_3" />
            </div>
          )}

          <AllFeed
            hasSlug={true}
            adModel={combinedAdModel}
            stories={get(this.props, 'allFeed.posts')}
            allRendered={get(this.props, 'allFeed.allRendered')}
            paginationEnabled={true}
            totalPages={totalPages}
            page={page}
            section="all"
            type="homepage"
            isLastPage={isLastPage}
            infiniteScrollEnabled={true}
            infiniteScrollAllFeedFetch={this.props.allISFeedActions}
            infiniteScrollLoading={get(this.props, 'allFeed.isLoading')}
            config={config}
            hideRecircFeed={this.props.hideRecircFeed}
            mobileAdCount={[4, null, 5]}
          />

          {get(this.props, 'allFeed.isLoading') && <LoadingSpinner />}

          {get(this.props, 'allFeed.posts.length') ? (
            <div className="homepage-page__all-ad-container">
              <Ad {...combinedAdModel} name="flexiblebillboard_6" />
              <Ad {...combinedAdModel} name="mobilerectangle_6" />
            </div>
          ) : (
            ''
          )}
        </section>
      );
    }
    return (
      <section className="homepage-page">
        <section className="page-title">
          <Slug slugName="All Stories" className="all-page" linkTo="/all" />
        </section>
        <AllFeed
          config={config}
          hasSlug={false}
          adModel={combinedAdModel}
          stories={get(this.props, 'allFeed.posts')}
          allRendered={get(this.props, 'allFeed.allRendered')}
          paginationEnabled={true}
          page={page + 1}
          section="all"
          type="homepage"
          isLastPage={isLastPage}
        />

        {get(this.props, 'allFeed.posts.length') ? (
          <div className="homepage-page__all-ad-container">
            <Ad {...combinedAdModel} name="flexiblebillboard_6" />
            <Ad {...combinedAdModel} name="mobilerectangle_4" />
          </div>
        ) : (
          ''
        )}
      </section>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    allISFeedActions: allFeedISActions(dispatch),
    hideRecircFeed: hideRecircAction(dispatch)
  };
}

function mapStateToProps(state = {}) {
  return {
    config: state.config,
    scrollingModule: get(state, 'scrollingModule.data') || {},
    promoBanner: get(state, 'promoBanner.data') || {},
    featuredSponsoredCard: get(state, 'featuredSponsoredCard.data') || {},
    allFeed: {
      isLoading: get(state, 'allFeed.isLoading', false),
      allRendered: get(state, 'allFeed.allRendered', false),
      posts: get(state, 'allFeed.data.posts', []),
      page: get(state, 'allFeed.data.page'),
      totalPages: get(state, 'allFeed.data.totalPages')
    },
    homepageVideo: {
      playlist: get(state, 'homepageVideo.data.playlist', []),
      title: get(state, 'homepageVideo.data.title', ''),
      feedid: get(state, 'homepageVideo.data.feedid', '')
    },
    featuredFeed: {
      source: get(state, 'featuredFeed.data.source', ''),
      top: get(state, 'featuredFeed.data.top', []),
      featured: get(state, 'featuredFeed.data.featured', []),
      combined: get(state, 'featuredFeed.data.combined', [])
    },
    megatronNativeTile: {
      posts: get(state, 'megatronNativeTile.data.posts', [])
    },
    homepageTag: {
      tags: get(state, 'homepageTag.data.tags', []),
      posts: get(state, 'homepageTag.data.posts', [])
    },
    homepageFeatureTerm: get(state, 'homepageFeatureTerm', {}),
    homepage: state.homepage || {},
    magazineLatestIssuePosts: get(state, 'magazineLatestIssuePosts') || {}
  };
}

Homepage.propTypes = {
  config: PropTypes.shape({}).isRequired,
  homepage: PropTypes.shape({
    ads: PropTypes.object,
    error: PropTypes.bool,
    isLoading: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  homepageVideo: PropTypes.shape({
    playlist: PropTypes.arrayOf(PropTypes.shape({})),
    feedid: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  homepageTag: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.shape({})),
    posts: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  homepageFeatureTerm: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    name: PropTypes.string,
    slug: PropTypes.string
  }).isRequired,
  scrollingModule: PropTypes.shape({}).isRequired,
  promoBanner: PropTypes.shape({}).isRequired,
  featuredSponsoredCard: PropTypes.shape({}).isRequired,
  allFeed: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    allRendered: PropTypes.bool
  }).isRequired,
  featuredFeed: PropTypes.shape({
    source: PropTypes.string,
    featured: PropTypes.arrayOf(PropTypes.shape({})),
    top: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  megatronNativeTile: PropTypes.shape({
    data: PropTypes.shape({
      posts: PropTypes.arrayOf(PropTypes.shape({}))
    })
  }).isRequired,
  allISFeedActions: PropTypes.func.isRequired,
  hideRecircFeed: PropTypes.func.isRequired,
  magazineLatestIssuePosts: PropTypes.shape({}).isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(Homepage);
